var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _use73, _use74, _use75, _use76, _use77, _use78, _use79, _use80, _use81, _use82, _use83, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91, _use92, _use93, _use94, _use95, _use96, _use97, _use98, _use99, _use100, _use101, _use102, _use103, _use104, _use105, _use106, _use107, _use108, _use109, _use110, _use111, _use112, _use113, _use114, _use115, _use116, _use117, _use118, _use119, _use120, _use121, _use122, _use123, _use124, _use125, _use126, _use127, _use128, _use129, _use130, _use131, _use132, _use133, _use134, _use135, _use136, _use137, _use138, _use139, _use140, _use141, _use142, _use143, _use144, _use145, _use146, _use147, _use148, _use149, _use150, _use151, _use152, _use153, _use154, _use155, _use156, _use157, _use158, _use159, _use160, _use161, _use162, _use163, _use164, _use165, _use166, _use167, _use168, _use169, _use170, _use171, _use172, _use173, _use174, _use175, _use176, _use177, _use178, _use179, _use180, _use181, _use182, _use183, _use184, _use185, _use186, _use187, _use188, _use189, _use190, _use191, _use192, _use193, _use194, _use195, _use196, _use197, _use198, _use199, _use200, _use201, _use202, _use203, _use204, _use205, _use206, _use207, _use208, _use209, _use210, _use211, _use212, _use213, _use214, _use215, _use216, _use217, _use218, _use219, _use220, _use221, _use222, _use223, _use224, _use225, _use226, _use227, _use228, _use229, _use230, _use231, _use232, _use233, _use234, _use235, _use236, _use237, _use238, _use239, _use240, _use241, _use242, _use243, _use244, _use245, _use246, _use247, _use248, _use249, _use250, _use251, _use252, _use253, _use254, _use255, _use256, _use257, _use258, _use259, _use260, _use261, _use262, _use263, _use264, _use265, _use266, _use267;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerfectMagicCube5Slices850(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "400pt",
    height: "74pt",
    viewBox: "0 0 400 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.75 -1.375 L 4.625 -1.421875 C 4.25 -0.84375 4.140625 -0.765625 3.671875 -0.765625 L 1.28125 -0.765625 L 2.953125 -2.515625 C 3.84375 -3.453125 4.234375 -4.203125 4.234375 -4.984375 C 4.234375 -5.984375 3.4375 -6.765625 2.390625 -6.765625 C 1.84375 -6.765625 1.3125 -6.546875 0.953125 -6.140625 C 0.625 -5.796875 0.484375 -5.484375 0.3125 -4.765625 L 0.515625 -4.71875 C 0.921875 -5.703125 1.265625 -6.015625 1.96875 -6.015625 C 2.8125 -6.015625 3.375 -5.453125 3.375 -4.609375 C 3.375 -3.8125 2.921875 -2.90625 2.078125 -2.015625 L 0.296875 -0.125 L 0.296875 0 L 4.203125 0 Z M 4.75 -1.375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.8125 -5.828125 L 3.765625 -5.828125 C 3.9375 -5.828125 3.96875 -5.84375 4 -5.921875 L 4.375 -6.8125 L 4.296875 -6.875 C 4.140625 -6.6875 4.046875 -6.625 3.828125 -6.625 L 1.734375 -6.625 L 0.65625 -4.25 C 0.640625 -4.234375 0.640625 -4.21875 0.640625 -4.203125 C 0.640625 -4.140625 0.6875 -4.125 0.765625 -4.125 C 1.078125 -4.125 1.46875 -4.046875 1.890625 -3.921875 C 3.046875 -3.546875 3.5625 -2.9375 3.5625 -1.9375 C 3.5625 -0.984375 2.953125 -0.234375 2.171875 -0.234375 C 1.96875 -0.234375 1.8125 -0.296875 1.515625 -0.515625 C 1.1875 -0.765625 0.96875 -0.84375 0.734375 -0.84375 C 0.453125 -0.84375 0.3125 -0.734375 0.3125 -0.484375 C 0.3125 -0.09375 0.78125 0.140625 1.546875 0.140625 C 2.375 0.140625 3.09375 -0.125 3.59375 -0.640625 C 4.046875 -1.09375 4.265625 -1.65625 4.265625 -2.421875 C 4.265625 -3.140625 4.0625 -3.59375 3.578125 -4.09375 C 3.140625 -4.546875 2.5625 -4.765625 1.390625 -4.984375 Z M 1.8125 -5.828125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.1875 0 L 3.9375 0 L 3.9375 -0.15625 C 3.171875 -0.15625 3 -0.265625 2.984375 -0.734375 L 2.984375 -6.734375 L 2.90625 -6.765625 L 1.109375 -5.84375 L 1.109375 -5.703125 C 1.5 -5.859375 1.734375 -5.9375 1.828125 -5.9375 C 2.046875 -5.9375 2.125 -5.78125 2.125 -5.453125 L 2.125 -0.9375 C 2.109375 -0.296875 1.9375 -0.15625 1.1875 -0.15625 Z M 1.1875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.453125 -6.84375 C 3.3125 -6.734375 2.734375 -6.546875 2.015625 -6.046875 C 0.9375 -5.265625 0.34375 -4.125 0.34375 -2.796875 C 0.34375 -1.921875 0.609375 -1.046875 1.046875 -0.546875 C 1.421875 -0.09375 1.953125 0.140625 2.578125 0.140625 C 3.8125 0.140625 4.6875 -0.8125 4.6875 -2.1875 C 4.6875 -3.484375 3.953125 -4.28125 2.796875 -4.28125 C 2.34375 -4.28125 2.15625 -4.203125 1.515625 -3.828125 C 1.796875 -5.34375 2.90625 -6.421875 4.484375 -6.6875 Z M 2.421875 -3.8125 C 3.296875 -3.8125 3.78125 -3.09375 3.78125 -1.84375 C 3.78125 -0.75 3.390625 -0.140625 2.6875 -0.140625 C 1.8125 -0.140625 1.265625 -1.078125 1.265625 -2.625 C 1.265625 -3.140625 1.34375 -3.421875 1.546875 -3.5625 C 1.765625 -3.734375 2.0625 -3.8125 2.421875 -3.8125 Z M 2.421875 -3.8125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.90625 -3.703125 C 3.90625 -4.25 4.234375 -4.65625 4.234375 -5.34375 C 4.234375 -6.171875 3.53125 -6.765625 2.515625 -6.765625 C 1.4375 -6.765625 0.625 -6.09375 0.625 -5.1875 C 0.625 -4.53125 0.8125 -4.234375 1.859375 -3.3125 C 0.765625 -2.484375 0.5625 -2.203125 0.5625 -1.515625 C 0.5625 -0.53125 1.34375 0.140625 2.484375 0.140625 C 3.6875 0.140625 4.453125 -0.515625 4.453125 -1.546875 C 4.453125 -2.3125 4.109375 -2.796875 2.90625 -3.703125 Z M 2.71875 -2.6875 C 3.453125 -2.15625 3.6875 -1.796875 3.6875 -1.234375 C 3.6875 -0.59375 3.234375 -0.140625 2.59375 -0.140625 C 1.828125 -0.140625 1.3125 -0.71875 1.3125 -1.578125 C 1.3125 -2.234375 1.53125 -2.640625 2.125 -3.125 Z M 2.609375 -3.890625 C 1.71875 -4.46875 1.359375 -4.9375 1.359375 -5.484375 C 1.359375 -6.0625 1.8125 -6.484375 2.4375 -6.484375 C 3.125 -6.484375 3.546875 -6.046875 3.546875 -5.34375 C 3.546875 -4.734375 3.296875 -4.34375 2.609375 -3.890625 Z M 2.609375 -3.890625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.546875 -6.765625 C 1.984375 -6.765625 1.5625 -6.59375 1.203125 -6.234375 C 0.625 -5.6875 0.234375 -4.53125 0.234375 -3.359375 C 0.234375 -2.265625 0.5625 -1.09375 1.046875 -0.546875 C 1.40625 -0.09375 1.921875 0.140625 2.5 0.140625 C 3.015625 0.140625 3.4375 -0.03125 3.796875 -0.375 C 4.375 -0.9375 4.765625 -2.09375 4.765625 -3.296875 C 4.765625 -5.34375 3.84375 -6.765625 2.546875 -6.765625 Z M 2.515625 -6.5 C 3.34375 -6.5 3.796875 -5.375 3.796875 -3.28125 C 3.796875 -1.1875 3.359375 -0.125 2.5 -0.125 C 1.640625 -0.125 1.203125 -1.1875 1.203125 -3.265625 C 1.203125 -5.40625 1.65625 -6.5 2.515625 -6.5 Z M 2.515625 -6.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.71875 -2.3125 L 3.703125 -2.3125 L 3.703125 -6.765625 L 3.265625 -6.765625 L 0.125 -2.3125 L 0.125 -1.671875 L 2.9375 -1.671875 L 2.9375 0 L 3.703125 0 L 3.703125 -1.671875 L 4.71875 -1.671875 Z M 2.921875 -2.3125 L 0.515625 -2.3125 L 2.921875 -5.734375 Z M 2.921875 -2.3125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.59375 0.21875 C 1.703125 0.09375 2.265625 -0.09375 2.9375 -0.59375 C 3.984375 -1.34375 4.59375 -2.59375 4.59375 -3.9375 C 4.59375 -5.59375 3.6875 -6.765625 2.375 -6.765625 C 1.1875 -6.765625 0.296875 -5.75 0.296875 -4.40625 C 0.296875 -3.1875 1.015625 -2.375 2.09375 -2.375 C 2.65625 -2.375 3.0625 -2.53125 3.59375 -2.9375 C 3.1875 -1.3125 2.078125 -0.234375 0.5625 0.015625 Z M 3.625 -3.546875 C 3.625 -3.34375 3.578125 -3.265625 3.46875 -3.171875 C 3.203125 -2.9375 2.8125 -2.796875 2.453125 -2.796875 C 1.703125 -2.796875 1.21875 -3.546875 1.21875 -4.734375 C 1.21875 -5.3125 1.375 -5.90625 1.59375 -6.171875 C 1.765625 -6.375 2.015625 -6.484375 2.296875 -6.484375 C 3.171875 -6.484375 3.625 -5.625 3.625 -3.9375 Z M 3.625 -3.546875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.484375 -6.625 L 0.796875 -6.625 L 0.203125 -5.15625 L 0.375 -5.0625 C 0.78125 -5.734375 0.96875 -5.875 1.53125 -5.875 L 3.703125 -5.875 L 1.71875 0.078125 L 2.375 0.078125 L 4.484375 -6.453125 Z M 4.484375 -6.625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.53125 -3.296875 C 2.125 -3.296875 2.34375 -3.28125 2.578125 -3.1875 C 3.203125 -2.953125 3.59375 -2.40625 3.59375 -1.703125 C 3.59375 -0.859375 3.03125 -0.21875 2.296875 -0.21875 C 2.015625 -0.21875 1.8125 -0.296875 1.4375 -0.53125 C 1.15625 -0.703125 0.984375 -0.78125 0.8125 -0.78125 C 0.578125 -0.78125 0.4375 -0.640625 0.4375 -0.4375 C 0.4375 -0.078125 0.859375 0.140625 1.5625 0.140625 C 2.3125 0.140625 3.109375 -0.125 3.59375 -0.53125 C 4.0625 -0.9375 4.3125 -1.515625 4.3125 -2.1875 C 4.3125 -2.703125 4.15625 -3.171875 3.875 -3.484375 C 3.65625 -3.703125 3.46875 -3.8125 3.046875 -4.015625 C 3.71875 -4.484375 3.96875 -4.84375 3.96875 -5.390625 C 3.96875 -6.203125 3.34375 -6.765625 2.40625 -6.765625 C 1.90625 -6.765625 1.46875 -6.59375 1.109375 -6.265625 C 0.8125 -5.984375 0.65625 -5.734375 0.453125 -5.140625 L 0.59375 -5.09375 C 1 -5.84375 1.453125 -6.15625 2.078125 -6.15625 C 2.734375 -6.15625 3.1875 -5.734375 3.1875 -5.09375 C 3.1875 -4.734375 3.03125 -4.375 2.78125 -4.125 C 2.484375 -3.8125 2.203125 -3.671875 1.515625 -3.4375 Z M 1.53125 -3.296875 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 113.984375 34.414062 L 785.15625 34.414062 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 113.984375 168.632812 L 785.15625 168.632812 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 113.984375 302.851562 L 785.15625 302.851562 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 113.984375 437.109375 L 785.15625 437.109375 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 113.984375 571.328125 L 785.15625 571.328125 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 113.984375 705.585938 L 785.15625 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 113.984375 34.414062 L 113.984375 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 248.203125 34.414062 L 248.203125 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 382.460938 34.414062 L 382.460938 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 516.679688 34.414062 L 516.679688 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 650.898438 34.414062 L 650.898438 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 785.15625 34.414062 L 785.15625 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 13.1094,
    y: 13.1539
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 18.1094,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 26.53245,
    y: 13.1539
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 31.53245,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 39.95628,
    y: 13.1539
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 44.95628,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 50.880108,
    y: 13.1539
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 55.880108,
    y: 13.1539
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 60.880108,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 66.803546,
    y: 13.1539
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 71.803546,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 10.6094,
    y: 26.5769
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 15.6094,
    y: 26.5769
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 20.6094,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 26.532447,
    y: 26.5769
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 31.532447,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 42.456277,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 55.880107,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 66.803547,
    y: 26.5769
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 71.803547,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 13.1094,
    y: 40.0007
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 18.1094,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 24.032447,
    y: 40.0007
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 29.032447,
    y: 40.0007
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 34.032447,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 39.956275,
    y: 40.0007
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 44.956275,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 55.880105,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 66.803545,
    y: 40.0007
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 71.803545,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 13.1094,
    y: 53.4249
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 18.1094,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 26.53245,
    y: 53.4249
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 31.53245,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 39.95628,
    y: 53.4249
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 44.95628,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 50.880108,
    y: 53.4249
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 55.880108,
    y: 53.4249
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 60.880108,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 66.803546,
    y: 53.4249
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 71.803546,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 13.1094,
    y: 66.8479
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 18.1094,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 26.53245,
    y: 66.8479
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 31.53245,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 37.456278,
    y: 66.8479
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 42.456278,
    y: 66.8479
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 47.456278,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 50.880108,
    y: 66.8479
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 55.880108,
    y: 66.8479
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 60.880108,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,0%,0%)",
      fillOpacity: 1
    }
  }, _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 69.303548,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 889.179688 34.414062 L 1560.390625 34.414062 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 889.179688 168.632812 L 1560.390625 168.632812 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 889.179688 302.851562 L 1560.390625 302.851562 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 889.179688 437.109375 L 1560.390625 437.109375 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 889.179688 571.328125 L 1560.390625 571.328125 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 889.179688 705.585938 L 1560.390625 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 889.179688 34.414062 L 889.179688 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1023.4375 34.414062 L 1023.4375 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1157.65625 34.414062 L 1157.65625 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1291.914062 34.414062 L 1291.914062 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1426.132812 34.414062 L 1426.132812 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1560.390625 34.414062 L 1560.390625 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 90.6309,
    y: 13.1539
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 95.6309,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 104.05434,
    y: 13.1539
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 109.05434,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 117.47817,
    y: 13.1539
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 122.47817,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 133.40239,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 144.32544,
    y: 13.1539
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 149.32544,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 90.6309,
    y: 26.5769
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 95.6309,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 104.05434,
    y: 26.5769
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 109.05434,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 114.978168,
    y: 26.5769
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 119.978168,
    y: 26.5769
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 124.978168,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 130.902387,
    y: 26.5769
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 135.902387,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 144.325437,
    y: 26.5769
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 149.325437,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 90.6309,
    y: 40.0007
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 95.6309,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 101.554338,
    y: 40.0007
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 106.554338,
    y: 40.0007
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 111.554338,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 117.478166,
    y: 40.0007
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 122.478166,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 128.402385,
    y: 40.0007
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 133.402385,
    y: 40.0007
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 138.402385,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 144.325432,
    y: 40.0007
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 149.325432,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 90.6309,
    y: 53.4245
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 95.6309,
    y: 53.4245
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 104.05434,
    y: 53.4245
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 109.05434,
    y: 53.4245
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 117.47817,
    y: 53.4245
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 122.47817,
    y: 53.4245
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 130.90239,
    y: 53.4245
  })), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 135.90239,
    y: 53.4245
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 141.825437,
    y: 53.4245
  })), _use94 || (_use94 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 146.825437,
    y: 53.4245
  })), _use95 || (_use95 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 151.825437,
    y: 53.4245
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use96 || (_use96 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 88.1309,
    y: 66.8475
  })), _use97 || (_use97 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 93.1309,
    y: 66.8475
  })), _use98 || (_use98 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 98.1309,
    y: 66.8475
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use99 || (_use99 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 104.054338,
    y: 66.8475
  })), _use100 || (_use100 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 109.054338,
    y: 66.8475
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use101 || (_use101 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 117.478168,
    y: 66.8475
  })), _use102 || (_use102 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 122.478168,
    y: 66.8475
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use103 || (_use103 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 130.902388,
    y: 66.8475
  })), _use104 || (_use104 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 135.902388,
    y: 66.8475
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,77.929688%,0%)",
      fillOpacity: 1
    }
  }, _use105 || (_use105 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 144.325438,
    y: 66.8475
  })), _use106 || (_use106 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 149.325438,
    y: 66.8475
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1664.414062 34.414062 L 2335.585938 34.414062 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1664.414062 168.632812 L 2335.585938 168.632812 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1664.414062 302.851562 L 2335.585938 302.851562 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1664.414062 437.109375 L 2335.585938 437.109375 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1664.414062 571.328125 L 2335.585938 571.328125 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1664.414062 705.585938 L 2335.585938 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1664.414062 34.414062 L 1664.414062 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1798.632812 34.414062 L 1798.632812 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1932.890625 34.414062 L 1932.890625 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2067.109375 34.414062 L 2067.109375 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2201.367188 34.414062 L 2201.367188 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2335.585938 34.414062 L 2335.585938 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use107 || (_use107 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 168.153,
    y: 13.1539
  })), _use108 || (_use108 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 173.153,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use109 || (_use109 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 181.57605,
    y: 13.1539
  })), _use110 || (_use110 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 186.57605,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use111 || (_use111 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 194.99988,
    y: 13.1539
  })), _use112 || (_use112 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 199.99988,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use113 || (_use113 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 208.42371,
    y: 13.1539
  })), _use114 || (_use114 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 213.42371,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use115 || (_use115 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 221.84715,
    y: 13.1539
  })), _use116 || (_use116 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 226.84715,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use117 || (_use117 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 165.653,
    y: 26.5769
  })), _use118 || (_use118 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 170.653,
    y: 26.5769
  })), _use119 || (_use119 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 175.653,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use120 || (_use120 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 181.576047,
    y: 26.5769
  })), _use121 || (_use121 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 186.576047,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use122 || (_use122 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 194.999877,
    y: 26.5769
  })), _use123 || (_use123 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 199.999877,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use124 || (_use124 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 208.423707,
    y: 26.5769
  })), _use125 || (_use125 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 213.423707,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use126 || (_use126 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 221.847147,
    y: 26.5769
  })), _use127 || (_use127 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 226.847147,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use128 || (_use128 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 168.153,
    y: 40.0007
  })), _use129 || (_use129 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 173.153,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use130 || (_use130 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 181.57605,
    y: 40.0007
  })), _use131 || (_use131 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 186.57605,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use132 || (_use132 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 194.99988,
    y: 40.0007
  })), _use133 || (_use133 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 199.99988,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use134 || (_use134 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 208.42371,
    y: 40.0007
  })), _use135 || (_use135 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 213.42371,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use136 || (_use136 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 221.84715,
    y: 40.0007
  })), _use137 || (_use137 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 226.84715,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use138 || (_use138 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 168.153,
    y: 53.4249
  })), _use139 || (_use139 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 173.153,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use140 || (_use140 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 181.57605,
    y: 53.4249
  })), _use141 || (_use141 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 186.57605,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use142 || (_use142 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 194.99988,
    y: 53.4249
  })), _use143 || (_use143 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 199.99988,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use144 || (_use144 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 208.42371,
    y: 53.4249
  })), _use145 || (_use145 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 213.42371,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use146 || (_use146 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 221.84715,
    y: 53.4249
  })), _use147 || (_use147 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 226.84715,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use148 || (_use148 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 168.153,
    y: 66.8479
  })), _use149 || (_use149 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 173.153,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use150 || (_use150 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 181.57605,
    y: 66.8479
  })), _use151 || (_use151 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 186.57605,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use152 || (_use152 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 194.99988,
    y: 66.8479
  })), _use153 || (_use153 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 199.99988,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use154 || (_use154 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 208.42371,
    y: 66.8479
  })), _use155 || (_use155 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 213.42371,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,100%,0%)",
      fillOpacity: 1
    }
  }, _use156 || (_use156 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 221.84715,
    y: 66.8479
  })), _use157 || (_use157 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 226.84715,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2439.648438 34.414062 L 3110.820312 34.414062 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2439.648438 168.632812 L 3110.820312 168.632812 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2439.648438 302.851562 L 3110.820312 302.851562 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2439.648438 437.109375 L 3110.820312 437.109375 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2439.648438 571.328125 L 3110.820312 571.328125 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2439.648438 705.585938 L 3110.820312 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2439.648438 34.414062 L 2439.648438 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2573.867188 34.414062 L 2573.867188 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2708.085938 34.414062 L 2708.085938 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2842.34375 34.414062 L 2842.34375 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2976.5625 34.414062 L 2976.5625 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3110.820312 34.414062 L 3110.820312 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use158 || (_use158 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 245.675,
    y: 13.1539
  })), _use159 || (_use159 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 250.675,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use160 || (_use160 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 259.09805,
    y: 13.1539
  })), _use161 || (_use161 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 264.09805,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use162 || (_use162 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 270.022269,
    y: 13.1539
  })), _use163 || (_use163 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 275.022269,
    y: 13.1539
  })), _use164 || (_use164 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 280.022269,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use165 || (_use165 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 283.446099,
    y: 13.1539
  })), _use166 || (_use166 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 288.446099,
    y: 13.1539
  })), _use167 || (_use167 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 293.446099,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use168 || (_use168 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 299.369537,
    y: 13.1539
  })), _use169 || (_use169 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 304.369537,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use170 || (_use170 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 245.675,
    y: 26.5769
  })), _use171 || (_use171 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 250.675,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use172 || (_use172 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 259.09805,
    y: 26.5769
  })), _use173 || (_use173 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 264.09805,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use174 || (_use174 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 272.52227,
    y: 26.5769
  })), _use175 || (_use175 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 277.52227,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use176 || (_use176 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 285.9461,
    y: 26.5769
  })), _use177 || (_use177 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 290.9461,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use178 || (_use178 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 296.869538,
    y: 26.5769
  })), _use179 || (_use179 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 301.869538,
    y: 26.5769
  })), _use180 || (_use180 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 306.869538,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use181 || (_use181 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 243.175,
    y: 40.0007
  })), _use182 || (_use182 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 248.175,
    y: 40.0007
  })), _use183 || (_use183 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 253.175,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use184 || (_use184 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 261.59805,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use185 || (_use185 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 270.02227,
    y: 40.0007
  })), _use186 || (_use186 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 275.02227,
    y: 40.0007
  })), _use187 || (_use187 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 280.02227,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use188 || (_use188 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 288.4461,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use189 || (_use189 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 299.36954,
    y: 40.0007
  })), _use190 || (_use190 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 304.36954,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use191 || (_use191 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 243.175,
    y: 53.4249
  })), _use192 || (_use192 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 248.175,
    y: 53.4249
  })), _use193 || (_use193 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 253.175,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use194 || (_use194 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 259.098047,
    y: 53.4249
  })), _use195 || (_use195 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 264.098047,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use196 || (_use196 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 275.022267,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use197 || (_use197 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 285.946097,
    y: 53.4249
  })), _use198 || (_use198 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 290.946097,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use199 || (_use199 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 299.369537,
    y: 53.4249
  })), _use200 || (_use200 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 304.369537,
    y: 53.4249
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use201 || (_use201 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 245.675,
    y: 66.8479
  })), _use202 || (_use202 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 250.675,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use203 || (_use203 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 256.598047,
    y: 66.8479
  })), _use204 || (_use204 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 261.598047,
    y: 66.8479
  })), _use205 || (_use205 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 266.598047,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use206 || (_use206 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 272.522266,
    y: 66.8479
  })), _use207 || (_use207 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 277.522266,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use208 || (_use208 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 285.946096,
    y: 66.8479
  })), _use209 || (_use209 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 290.946096,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,100%)",
      fillOpacity: 1
    }
  }, _use210 || (_use210 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 299.369536,
    y: 66.8479
  })), _use211 || (_use211 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 304.369536,
    y: 66.8479
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3214.84375 34.414062 L 3886.015625 34.414062 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3214.84375 168.632812 L 3886.015625 168.632812 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3214.84375 302.851562 L 3886.015625 302.851562 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3214.84375 437.109375 L 3886.015625 437.109375 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3214.84375 571.328125 L 3886.015625 571.328125 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3214.84375 705.585938 L 3886.015625 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3214.84375 34.414062 L 3214.84375 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3349.101562 34.414062 L 3349.101562 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3483.320312 34.414062 L 3483.320312 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3617.539062 34.414062 L 3617.539062 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3751.796875 34.414062 L 3751.796875 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3886.015625 34.414062 L 3886.015625 705.585938 ",
    transform: "matrix(0.1,0,0,-0.1,0,74)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use212 || (_use212 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 320.696,
    y: 13.1539
  })), _use213 || (_use213 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 325.696,
    y: 13.1539
  })), _use214 || (_use214 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 330.696,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use215 || (_use215 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 334.11905,
    y: 13.1539
  })), _use216 || (_use216 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 339.11905,
    y: 13.1539
  })), _use217 || (_use217 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 344.11905,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use218 || (_use218 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 352.54327,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use219 || (_use219 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 363.4671,
    y: 13.1539
  })), _use220 || (_use220 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 368.4671,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use221 || (_use221 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 376.89015,
    y: 13.1539
  })), _use222 || (_use222 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 381.89015,
    y: 13.1539
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use223 || (_use223 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 323.196,
    y: 26.5769
  })), _use224 || (_use224 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 328.196,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use225 || (_use225 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 336.61905,
    y: 26.5769
  })), _use226 || (_use226 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 341.61905,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use227 || (_use227 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 347.543269,
    y: 26.5769
  })), _use228 || (_use228 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 352.543269,
    y: 26.5769
  })), _use229 || (_use229 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 357.543269,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use230 || (_use230 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 360.967099,
    y: 26.5769
  })), _use231 || (_use231 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 365.967099,
    y: 26.5769
  })), _use232 || (_use232 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 370.967099,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use233 || (_use233 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 376.890146,
    y: 26.5769
  })), _use234 || (_use234 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 381.890146,
    y: 26.5769
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use235 || (_use235 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 323.196,
    y: 40.0007
  })), _use236 || (_use236 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 328.196,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use237 || (_use237 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 336.61905,
    y: 40.0007
  })), _use238 || (_use238 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 341.61905,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use239 || (_use239 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 350.04327,
    y: 40.0007
  })), _use240 || (_use240 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 355.04327,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use241 || (_use241 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 360.967098,
    y: 40.0007
  })), _use242 || (_use242 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 365.967098,
    y: 40.0007
  })), _use243 || (_use243 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 370.967098,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use244 || (_use244 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 376.890145,
    y: 40.0007
  })), _use245 || (_use245 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 381.890145,
    y: 40.0007
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use246 || (_use246 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 323.196,
    y: 53.4245
  })), _use247 || (_use247 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 328.196,
    y: 53.4245
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use248 || (_use248 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 336.61905,
    y: 53.4245
  })), _use249 || (_use249 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 341.61905,
    y: 53.4245
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use250 || (_use250 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 350.04327,
    y: 53.4245
  })), _use251 || (_use251 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 355.04327,
    y: 53.4245
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use252 || (_use252 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 363.4671,
    y: 53.4245
  })), _use253 || (_use253 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 368.4671,
    y: 53.4245
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use254 || (_use254 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 376.89015,
    y: 53.4245
  })), _use255 || (_use255 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 381.89015,
    y: 53.4245
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use256 || (_use256 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 323.196,
    y: 66.8475
  })), _use257 || (_use257 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 328.196,
    y: 66.8475
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use258 || (_use258 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 334.119047,
    y: 66.8475
  })), _use259 || (_use259 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 339.119047,
    y: 66.8475
  })), _use260 || (_use260 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 344.119047,
    y: 66.8475
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use261 || (_use261 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 350.043266,
    y: 66.8475
  })), _use262 || (_use262 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 355.043266,
    y: 66.8475
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use263 || (_use263 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 363.467096,
    y: 66.8475
  })), _use264 || (_use264 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 368.467096,
    y: 66.8475
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(56.054688%,37.010193%,59.959412%)",
      fillOpacity: 1
    }
  }, _use265 || (_use265 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 374.390143,
    y: 66.8475
  })), _use266 || (_use266 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 379.390143,
    y: 66.8475
  })), _use267 || (_use267 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 384.390143,
    y: 66.8475
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectMagicCube5Slices850);
export default __webpack_public_path__ + "static/media/PerfectMagicCube5Slices_850.a9c931fdf1f1696c07c2665367e30196.svg";
export { ForwardRef as ReactComponent };